import { browser } from "./env"
import { Logger } from "./logger";

const logger = new Logger("once");

/**
 * @template {any} T
 * @param {string} id 
 * @param {NodeList | Array<Element> | Element | string} selector The element(s)
 * @param {Document | Element | null} [context=null]
 * @param {((x: any) => x is T)?} [guard=null]
 * @returns {IterableIterator<T>}
 */
export function* once(id, selector, context = null, guard = null) {
	if (!browser || !selector) return;
	if (!context) context = document;

	if (selector instanceof Element) {
		if (process(id, selector, guard)) {
			yield /** @type {T} */ (selector);
		}
	} else if (Array.isArray(selector)) {
		for (let element of selector) {
			if (process(id, element, guard)) {
				yield /** @type {T} */ (element);
			}
		}
	} else {
		const nodes = typeof(selector) === "string" ? context.querySelectorAll(`:scope ${selector}`) : selector;
		for (let node of nodes) {
			if (process(id, node, guard)) {
				yield /** @type {T} */ (node);
			}
		}
	}

	/**
	 * @template {any} T
	 * @param {string} id 
	 * @param {Node} node
	* @param {((x: any) => x is T)?} [guard=null]
	 * @returns {boolean}
	 */
	function process(id, node, guard) {
		if (node instanceof HTMLElement) {

			if (guard && guard(node)) {
				/** @type {string[]} */
				let done = [];
				if (!node.dataset.once) {
					node.dataset.once = "";
				} else {
					done = node.dataset.once.split(",");
				}

				if (!done.includes(id)) {
					done.push(id);
					node.dataset.once = done.join(",");
					return true;
				}
			} else if (guard) {
				logger.debug(`Guard failed while processing element with id '${id}': `, node);
			}

		} else {
			logger.warn(`Attempted to process non-HTMLElement with id '${id}': `, node);
		}
		return false;
	}
}